import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePayment } from "../context/paymentContext";

/**
 * Stands in front of a journey's steps once its payment has been sent. A
 * browser Back from the outcome page lands here, and is shown that payment's
 * outcome again rather than a Confirm step one press from paying twice. Try
 * again clears the marker on purpose, and a success clears the whole journey.
 */
export const SubmittedPaymentGuard = ({ children }: { children: ReactNode }) => {
  const { submittedOutcome } = usePayment();
  if (submittedOutcome) {
    return (
      <Navigate
        to={submittedOutcome.to}
        replace
        state={submittedOutcome.state}
      />
    );
  }
  return <>{children}</>;
};

export default SubmittedPaymentGuard;
